import { makeAutoObservable } from 'mobx'

class FolderSyncStore {
	private _startWatchingCallback: ( () => void ) | null = null
	watchingStarted = false

	constructor() {
		makeAutoObservable( this )
	}

	get isFolderSyncSupported() {
		return 'showDirectoryPicker' in window
	}

	setStartWatching( fn: () => void ) {
		this._startWatchingCallback = fn
	}

	unsetStartWatching() {
		this._startWatchingCallback = null
	}

	triggerStartWatching() {
		this._startWatchingCallback?.()
	}

	setWatchingStarted( value: boolean ) {
		this.watchingStarted = value
	}
}

export default FolderSyncStore
